import ConfigurableSectionLabel, {
  ConfigurableSectionLabelProps,
} from 'organization/Marketplace/config/ConfigurablePurchaseForm/ConfigurableSectionLabel'
import React from 'react'

export default function ConfigurableCompanyNameLabel(
  props: ConfigurableSectionLabelProps,
) {
  const {companyNameLabel} = props

  return (
    <ConfigurableSectionLabel
      {...props}
      children={companyNameLabel ?? 'Company'}
      inputName="companyNameLabel"
    />
  )
}
